import styled from '@emotion/styled'
import { ExtranetProductShortageOrderDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetCatalogItemChevron,
  ExtranetContainer,
  ExtranetExpandArrowColumn,
  ExtranetTableColumn,
  ExtranetTableGroupColumn,
  ExtranetTableRow,
  formatDateString,
  useBreakpoint,
} from '@pharmac-extranet/shared'
import { formatBirthdate } from '../../utils/formatters'
import { CatalogItemAvailability } from '../dose-dispensing-catalog/CatalogItemAvailability'
import { ProductShortagesCustomerDetails } from './ProductShortagesCustomerDetails'

export const HoverColumn = styled(ExtranetTableColumn)`
  :hover {
    overflow: auto;
    scrollbar-width: thin;
  }
`

type Props = {
  order: ExtranetProductShortageOrderDto
}

export const ProductShortagesCustomerRow = ({ order }: Props) => {
  const { minDesktop } = useBreakpoint()

  const firstProduct = order.products.map((a: any) => a).at(0)
  const filteredProducts = order.products
    .filter((product) => product !== firstProduct)
    .map((p) => p)

  return (
    <ExtranetTableRow
      noBorders
      noMargin
      style={{
        borderTop: '1px solid var(--color-accent-4)',
      }}
      expand={<>{!minDesktop && <ProductShortagesCustomerDetails order={order} />}</>}
      toggleExpand={() => null}
      children={({ isExpanded }) => (
        <ExtranetTableGroupColumn>
          <ExtranetTableRow>
            <ExtranetTableColumn
              marginSmallLeft
              size={1.4}
            >
              {order.wholeName}
            </ExtranetTableColumn>
            {minDesktop && (
              <>
                <ExtranetTableColumn size={0.8}>
                  {formatBirthdate(order.anonymizedSocialSecurityNumber)}
                </ExtranetTableColumn>
                <ExtranetTableColumn size={1.4}>
                  {formatDateString(order.startDate)}-{formatDateString(order.endDate)}
                </ExtranetTableColumn>
                <ExtranetTableColumn size={0.5}>{firstProduct?.productNumber}</ExtranetTableColumn>
                <HoverColumn size={1.7}>
                  {firstProduct?.nameFi} {firstProduct?.strength}
                </HoverColumn>
                <ExtranetTableColumn size={1}>
                  <ExtranetContainer flexRow>
                    <CatalogItemAvailability availability={firstProduct.availableForCustomers} />
                  </ExtranetContainer>
                </ExtranetTableColumn>
                <ExtranetTableColumn size={0.6}>
                  {firstProduct?.substituteProduct?.productNumber}
                </ExtranetTableColumn>
                <HoverColumn size={1.2}>
                  {firstProduct?.substituteProduct?.nameFi}{' '}
                  {firstProduct?.substituteProduct?.strength}
                </HoverColumn>
              </>
            )}

            {!minDesktop && (
              <ExtranetExpandArrowColumn>
                <ExtranetCatalogItemChevron isExpanded={isExpanded} />
              </ExtranetExpandArrowColumn>
            )}
          </ExtranetTableRow>
          {order.products.length > 1 &&
            minDesktop &&
            filteredProducts.map((a) => (
              <ExtranetTableRow
                key={a.id}
                noMargin
                noBorders
                style={{
                  borderTop: '2px dashed var(--color-accent-4)',
                  width: '58%',
                  alignSelf: 'flex-end',
                }}
              >
                <ExtranetTableColumn size={0.5}>{a.productNumber}</ExtranetTableColumn>
                <HoverColumn size={1.7}>
                  {a.nameFi} {a.strength}
                </HoverColumn>
                <ExtranetTableColumn size={1}>
                  <ExtranetContainer flexRow>
                    <CatalogItemAvailability availability={a.availableForCustomers} />
                  </ExtranetContainer>
                </ExtranetTableColumn>
                <ExtranetTableColumn size={0.6}>
                  {a.substituteProduct?.productNumber}
                </ExtranetTableColumn>
                <HoverColumn size={1.2}>
                  {a.substituteProduct?.nameFi} {a.substituteProduct?.strength}
                </HoverColumn>
              </ExtranetTableRow>
            ))}
        </ExtranetTableGroupColumn>
      )}
    />
  )
}
